/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import LabelAndInputTime from "../common/form/labelAndInputTime";
import Select from "../common/form/select";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import NewTr from "../common/table/newTr";
import Tr from "../common/table/tr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import FormatUtils from "../common/formatUtils/FormatUtils";
import DateFormat from "../common/dateFormat/DateFormat";

import {
    setModoTela,
    initForm,
    getLista,
    setFiltro,
    atualizarValoresFormulario,
    getListaDemandaCompetencia,
    adicionarHistorico,
    alterarHistorico,
    setListaDemandaCompetenciaAlteracao,
    getListaHistorico,
    getListaAgendamento,
    initFormAgendamento,
    buscarHorarioDiferenciado,
    salvarHorarioDiferenciado,
} from "./demandaContratoActions";
import FileChooser from "../common/form/fileChooser/fileChooser";
import BotaoExcluir from "../common/button/botaoExcluir";
import ButtonTable from "../common/table/buttonTable";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { DisplayPDF } from "../displayPDF/displayPDF";

function DemandaContratoForm(props) {
    const [state, setState] = useState({
        exibirCamposHorarioDiferenciado: !!props.formularioValues.horario_diferenciado,
        //se altera conforme cliques nos botões adicionar ou remover período de teste
        exibirCamposPeriodoTeste: (props.formularioValues.periodo_teste || []).length,
        //não se altera ao longo das iterações
        existiaPeriodoTesteCadastrado: (props.formularioValues.periodo_teste || []).length,
    });

    useEffect(() => {
        //se estiver filtrado mostra UCs que já possuem demanda no Adicionar,
        //sendo assim, é necessário resetar o filtro e carregar a lista completa novamente
        props.setFiltro({ ...props.filtro, id_cliente: null, id_unidade_consumidora: null });
        props.getLista();
        //--------------------------------------------------------------------------------
        props.getListaDemandaCompetencia(props.formularioValues.id);
        props.getListaAgendamento(props.formularioValues.id);
        if (props.formularioValues.competencia_inicio_periodo_teste && props.formularioValues.competencia_fim_periodo_teste) {
            setState({ ...state, existiaPeriodoTesteCadastrado: true });
        }
    }, []);

    useEffect(() => {
        if (!props.formularioValues.id) return;
        props.buscarHorarioDiferenciado({
            registro: props.formularioValues,
            callback: (horario_diferenciado) => setState({ ...state, exibirCamposHorarioDiferenciado: !!horario_diferenciado }),
        });
    }, [props.formularioValues.id]);

    useEffect(() => {
        if (props.filtro.id_tipo_contrato_demanda) {
            getListaDemandaCompetencia(props.formularioValues.id);
            getListaAgendamento(props.formularioValues.id);
        }
    }, [props.filtro.id_tipo_contrato_demanda]);

    function somarHoras(hora, horasAdicionar) {
        if (!hora) return null;

        var partes = hora.split(":");
        var h = parseInt(partes[0], 10);
        var m = parseInt(partes[1] || 0, 10);

        var data = new Date();
        data.setHours(h);
        data.setMinutes(m);
        data.setSeconds(0);

        data.setHours(data.getHours() + horasAdicionar);

        var hh = data.getHours();
        var mm = data.getMinutes();

        hh = hh < 10 ? "0" + hh : "" + hh;
        mm = mm < 10 ? "0" + mm : "" + mm;

        return hh + ":" + mm;
    }

    const usuarioLogado = props.usuarioLogado;
    let readOnly = !!(props.excluir || props.visualizar);

    let mes = parseInt(props.formularioValues.mes_inicio);

    let listaCicloRural = [];
    if (mes) {
        for (let i = 0; i < 12; i++) {
            const objetoMes = props.listaMeses.find((item) => item.id == mes);
            listaCicloRural.push(`${objetoMes.valor}`);
            mes = mes + 1 == 13 ? 1 : mes + 1;
        }
    }

    const listaUCsSelect = props.listaUnidadeConsumidora.filter((item) => {
        const implantacaoLogado = usuarioLogado.usuario_implantacao;
        const existeDemandaParaUC = props.lista.find((demanda) => demanda.id_unidade_consumidora == item.id && !demanda.encerrado);
        const condicaoImplantacao = !implantacaoLogado || item.id_usuario_implantacao == usuarioLogado.id;
        const condicaoGrupoA = [1, 4].includes(parseInt(item.id_grupo_faturamento));
        const condicaoExisteDemanda = !!props.formularioValues.id || !existeDemandaParaUC;
        const condicaoUcDoCliente = item.id_cliente == props.formularioValues.id_cliente;
        return condicaoImplantacao && condicaoGrupoA && condicaoExisteDemanda && condicaoUcDoCliente;
    });
    const ucSelecionada = listaUCsSelect.find((uc) => props.formularioValues.id_unidade_consumidora == uc.id);
    const msgUcSemModalidadeTarifaria = ucSelecionada && !ucSelecionada.id_modalidade_tarifaria ? "(Verifique a modalidade tarifária no cadastro da UC)" : "";

    const acessoPeriodoTesteValido =
        usuarioLogado.acesso_periodo_teste_demanda_visualizar ||
        usuarioLogado.acesso_periodo_teste_demanda_adicionar ||
        usuarioLogado.acesso_periodo_teste_demanda_editar ||
        usuarioLogado.acesso_periodo_teste_demanda_excluir;

    const acessoHorarioDiferenciadoValido =
        usuarioLogado.acesso_horario_diferenciado_demanda_visualizar ||
        usuarioLogado.acesso_horario_diferenciado_demanda_adicionar ||
        usuarioLogado.acesso_horario_diferenciado_demanda_editar ||
        usuarioLogado.acesso_horario_diferenciado_demanda_excluir;

    const semAcessoCadastroHorarioDiferenciado =
        !usuarioLogado.acesso_horario_diferenciado_demanda_adicionar &&
        !usuarioLogado.acesso_horario_diferenciado_demanda_editar &&
        !usuarioLogado.acesso_horario_diferenciado_demanda_excluir;

    const semAcessoCadastroPeriodoTeste =
        !usuarioLogado.acesso_periodo_teste_demanda_adicionar && !usuarioLogado.acesso_periodo_teste_demanda_editar && !usuarioLogado.acesso_periodo_teste_demanda_excluir;

    const horarioDiferenciado = props.formularioValues.horario_diferenciado || {};

    const podeAlterarHorarioDiferenciado =
        horarioDiferenciado.id ? usuarioLogado.acesso_horario_diferenciado_demanda_editar : usuarioLogado.acesso_horario_diferenciado_demanda_adicionar;

    const readOnlyHorarioDiferenciado = props.excluir || !podeAlterarHorarioDiferenciado;

    return (
        <>
            <DisplayPDF closePdf={props.setArquivoPDF} pdfBase64={props.pdf} nomePdf={props.nomePdf} orientation={props.orientation} zoomParametro={1.5} />
            <Form event={props.handleSubmit}>
                <ContentCard>
                    <ContentCardBody>
                        {props.formularioValues && props.formularioValues.id ? (
                            <>
                                <Row>
                                    <Grid cols="12 12 4 4">
                                        <Button
                                            text={props.formularioValues.arquivo_cusd ? "Contrato CUSD Importado (Substituir)" : "Importar Contrato CUSD"}
                                            type={"primary"}
                                            icon={"fa fa-file-import"}
                                            disabled={readOnly}
                                            event={() => {
                                                props.setModoTela("importarCusd", props.formularioValues);
                                            }}
                                        />
                                    </Grid>
                                    <Grid cols="12 12 4 4">
                                        <Button
                                            text={props.formularioValues.arquivo_ccer ? "Contrato CCER Importado (Substituir)" : "Importar Contrato CCER"}
                                            type={"primary"}
                                            icon={"fa fa-file-import"}
                                            disabled={readOnly}
                                            event={() => {
                                                props.setModoTela("importarCcer", props.formularioValues);
                                            }}
                                        />
                                    </Grid>
                                    <Grid cols="12 12 4 4">
                                        <Button
                                            text={props.formularioValues.arquivo_ciclo_rural ? "Ciclo Sazonal Importado (Substituir)" : "Importar Ciclo Sazonal"}
                                            type={"primary"}
                                            icon={"fa fa-file-import"}
                                            disabled={readOnly}
                                            event={() => {
                                                props.setModoTela("importarCicloRural", props.formularioValues);
                                            }}
                                        />
                                    </Grid>
                                </Row>
                            </>
                        ) : null}

                        <br />
                        <Row>
                            <Field
                                name="id_cliente"
                                component={Select}
                                //se usuario implantacao estiver logado
                                //filtra para poder incluir apenas itens na UC
                                //que ele é o implantador
                                options={props.listaCliente.filter(
                                    (cliente) => !usuarioLogado.usuario_implantacao || cliente.itens.find((uc) => uc.id_usuario_implantacao == usuarioLogado.id)
                                )}
                                label="Cliente"
                                cols="12 12 12 12"
                                placeholder="Selecione o cliente"
                                readOnly={props.formularioValues.id ? "readOnly" : ""}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="id_unidade_consumidora"
                                component={Select}
                                //se usuario implantacao estiver logado
                                //filtra para poder incluir apenas itens na UC
                                //que ele é o implantador
                                options={listaUCsSelect}
                                label={
                                    <>
                                        Unidade Consumidora <span style={{ color: "red" }}>{msgUcSemModalidadeTarifaria}</span>
                                    </>
                                }
                                cols="12 12 12 12"
                                placeholder="Selecione a unidade consumidora"
                                readOnly={props.formularioValues.id ? "readOnly" : ""}
                            />
                        </Row>
                        {props.formularioValues.sazonal ? (
                            <>
                                <Row>
                                    <Select
                                        name="mes_inicio"
                                        options={props.listaMeses}
                                        label="Início do Ciclo Sazonal"
                                        cols="12 12 12 12"
                                        placeholder="Selecione o mês de início do ciclo sazonal"
                                        readOnly={props.formularioValues.id && ![1, 2].includes(props.usuarioLogado.id)}
                                        value={props.formularioValues.mes_inicio}
                                        onChange={(valor) => {
                                            props.initForm({
                                                ...props.formularioValues,
                                                mes_inicio: valor,
                                                mes_fim: valor == 1 ? parseInt(valor) + 11 : parseInt(valor) - 1,
                                            });
                                        }}
                                    />
                                </Row>
                                <Row>
                                    <Field
                                        name="mes_fim"
                                        component={Select}
                                        options={props.listaMeses.filter((mes) => mes.id == props.formularioValues.mes_fim)}
                                        label="Fim do Ciclo Sazonal"
                                        cols="12 12 12 12"
                                        placeholder="Fim do ciclo sazonal (Definido após selecionar o mês de início do ciclo sazonal)"
                                        readOnly={props.formularioValues.id && ![1, 2].includes(props.usuarioLogado.id)}
                                    />
                                </Row>
                            </>
                        ) : (
                            <Row>
                                <Field
                                    name="competencia_base_sazonalidade"
                                    component={LabelAndInputMask}
                                    label="Competência Início da Não Sazonalidade"
                                    placeholder="Informe a competência"
                                    cols="12 12 12 12"
                                    mask="99/9999"
                                    readOnly={props.formularioValues.id && ![1, 2].includes(props.usuarioLogado.id)}
                                    autoFocus={true}
                                />
                            </Row>
                        )}
                        <Row>
                            <Field name="observacao" component={LabelAndInput} label="Observação" placeholder="Informe a observação" cols="12 12 12 12" readOnly={readOnly} />
                        </Row>
                        {acessoPeriodoTesteValido ? (
                            <Row style={{ marginTop: 10 }}>
                                {usuarioLogado.acesso_periodo_teste_demanda_adicionar && !state.exibirCamposPeriodoTeste ? (
                                    <Grid cols="12 4 4 4">
                                        <Button
                                            text={"Ativar Período de Testes"}
                                            type={"info"}
                                            icon={"fa fa-stopwatch"}
                                            disabled={readOnly}
                                            event={() => {
                                                setState({ ...state, exibirCamposPeriodoTeste: !state.exibirCamposPeriodoTeste });
                                                props.initForm({
                                                    ...props.formularioValues,
                                                    competencia_inicio_periodo_teste: null,
                                                    competencia_fim_periodo_teste: null,
                                                });
                                            }}
                                        />
                                    </Grid>
                                ) : null}

                                {state.exibirCamposPeriodoTeste ? (
                                    <Grid
                                        cols="12 4 4 4"
                                        style={
                                            state.exibirCamposPeriodoTeste
                                                ? { padding: "14px 14px 0px 14px", margin: 5, borderRadius: 5, backgroundColor: "#e3e9ed" }
                                                : { padding: 0, margin: 0 }
                                        }
                                    >
                                        <Row>
                                            {usuarioLogado.acesso_periodo_teste_demanda_excluir ? (
                                                <Grid cols="12 12 12 12">
                                                    <Button
                                                        style={{ margin: 0, paddingBlock: 25 }}
                                                        text={"Remover período de testes"}
                                                        type={"danger"}
                                                        icon={"fa fa-times"}
                                                        disabled={readOnly}
                                                        event={() => {
                                                            setState({ ...state, exibirCamposPeriodoTeste: !state.exibirCamposPeriodoTeste });
                                                            props.initForm({
                                                                ...props.formularioValues,
                                                                competencia_inicio_periodo_teste: null,
                                                                competencia_fim_periodo_teste: null,
                                                            });
                                                        }}
                                                    />
                                                </Grid>
                                            ) : null}
                                            <Field
                                                name="competencia_inicio_periodo_teste"
                                                component={LabelAndInputMask}
                                                label="Início do Período de Testes"
                                                placeholder="MM/AAAA"
                                                cols="12 6 6 6"
                                                mask="99/9999"
                                                readOnly={readOnly || semAcessoCadastroPeriodoTeste}
                                            />
                                            <Field
                                                name="competencia_fim_periodo_teste"
                                                component={LabelAndInputMask}
                                                label="Fim do Período de Testes"
                                                placeholder="MM/AAAA"
                                                cols="12 6 6 6"
                                                mask="99/9999"
                                                readOnly={readOnly || semAcessoCadastroPeriodoTeste}
                                            />
                                        </Row>
                                    </Grid>
                                ) : null}
                            </Row>
                        ) : null}
                        {acessoHorarioDiferenciadoValido ? (
                            <Row style={{ marginTop: 10 }}>
                                {usuarioLogado.acesso_horario_diferenciado_demanda_adicionar && !state.exibirCamposHorarioDiferenciado ? (
                                    <>
                                        <Grid cols="12 4 4 4" style={{ padding: "12px 0px 0 10px" }}>
                                            <Grid cols="12 12 12 12" style={{ padding: "0px 3px 0px 3px" }}>
                                                <Button
                                                    style={{ margin: 0 }}
                                                    text={"Ativar Horário Ponta Diferenciado"}
                                                    type={"success"}
                                                    icon={"fa fa-stopwatch"}
                                                    disabled={props.excluir || !usuarioLogado.acesso_horario_diferenciado_demanda_adicionar}
                                                    event={() => {
                                                        setState({ ...state, exibirCamposHorarioDiferenciado: !state.exibirCamposHorarioDiferenciado });
                                                        props.initForm({
                                                            ...props.formularioValues,
                                                            horario_diferenciado: {
                                                                horario_inicio_ponta: "18:00",
                                                                horario_fim_ponta: "21:00",
                                                            },
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                            <Grid cols="12 12 12 12" style={{ padding: "12px 5px" }}>
                                                <div>
                                                    <b>Intervalos de Horário Padrão</b>
                                                </div>
                                                <div>
                                                    <b>Ponta: 18h às 21h</b>
                                                </div>
                                                <div>
                                                    <b>Reservado: 21:30 às 6h</b>
                                                </div>
                                                <div>
                                                    <b>Fora Ponta: Restante das Horas do Dia</b>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </>
                                ) : null}

                                {state.exibirCamposHorarioDiferenciado ? (
                                    <Grid
                                        cols={"12 4 4 4"}
                                        style={
                                            state.exibirCamposHorarioDiferenciado
                                                ? { padding: 10, margin: 5, borderRadius: 10, backgroundColor: "#e3e9ed" }
                                                : { padding: 0, margin: 0 }
                                        }
                                    >
                                        <Row>
                                            {usuarioLogado.acesso_horario_diferenciado_demanda_excluir && state.exibirCamposHorarioDiferenciado ? (
                                                <Grid cols="12 12 12 12">
                                                    <Button
                                                        style={{ margin: 0 }}
                                                        text={"Remover horário ponta diferenciado"}
                                                        type={"danger"}
                                                        icon={"fa fa-times"}
                                                        disabled={props.excluir || !usuarioLogado.acesso_horario_diferenciado_demanda_excluir}
                                                        event={() => {
                                                            setState({ ...state, exibirCamposHorarioDiferenciado: !state.exibirCamposHorarioDiferenciado });
                                                            props.initForm({ ...props.formularioValues, horario_diferenciado: null });
                                                        }}
                                                    />
                                                </Grid>
                                            ) : null}
                                            <LabelAndInputMask
                                                label="Início da Vigência do Horário"
                                                placeholder="MM/AAAA"
                                                cols="12 6 6 6"
                                                mask="99/9999"
                                                value={horarioDiferenciado.competencia_inicio_vigencia || null}
                                                readOnly={readOnlyHorarioDiferenciado}
                                                onChange={(e) => {
                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        horario_diferenciado: {
                                                            ...horarioDiferenciado,
                                                            competencia_inicio_vigencia: e.target.value,
                                                        },
                                                    });
                                                }}
                                            />
                                            <LabelAndInputMask
                                                label="Fim da Vigência do Horário"
                                                placeholder="MM/AAAA"
                                                cols="12 6 6 6"
                                                mask="99/9999"
                                                value={horarioDiferenciado.competencia_fim_vigencia || null}
                                                readOnly={readOnlyHorarioDiferenciado}
                                                onChange={(e) => {
                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        horario_diferenciado: {
                                                            ...horarioDiferenciado,
                                                            competencia_fim_vigencia: e.target.value,
                                                        },
                                                    });
                                                }}
                                            />
                                            <LabelAndInputTime
                                                label="Horário Inicial do Ponta"
                                                cols="12 6 6 6"
                                                readOnly={readOnlyHorarioDiferenciado}
                                                value={horarioDiferenciado.horario_inicio_ponta}
                                                onChange={(e) => {
                                                    const inicio = e.target.value;
                                                    const fimAutomatico = somarHoras(inicio, 3);

                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        horario_diferenciado: {
                                                            ...horarioDiferenciado,
                                                            horario_inicio_ponta: inicio,
                                                            horario_fim_ponta: fimAutomatico,
                                                        },
                                                    });
                                                }}
                                            />
                                            <LabelAndInputTime
                                                label="Horário Final do Ponta"
                                                cols="12 6 6 6"
                                                readOnly={readOnlyHorarioDiferenciado}
                                                value={horarioDiferenciado.horario_fim_ponta}
                                                onChange={(e) => {
                                                    props.initForm({
                                                        ...props.formularioValues,
                                                        horario_diferenciado: {
                                                            ...horarioDiferenciado,
                                                            horario_fim_ponta: e.target.value,
                                                        },
                                                    });
                                                }}
                                            />
                                            <Grid cols="12 12 12 12">
                                                {horarioDiferenciado.arquivo_contrato_horario ? (
                                                    <div
                                                        style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 20, border: "1px solid #ccc", margin: 5 }}
                                                    >
                                                        {readOnlyHorarioDiferenciado ? null : (
                                                            <div style={{ paddingLeft: 58 }}>
                                                                <BotaoExcluir
                                                                    event={() => {
                                                                        if (!window.confirm("Deseja realmente remover o arquivo?")) return;
                                                                        props.initForm({
                                                                            ...props.formularioValues,
                                                                            horario_diferenciado: {
                                                                                ...horarioDiferenciado,
                                                                                arquivo_contrato_horario: null,
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                        <ButtonTable
                                                            style={{ margin: "5px 20px" }}
                                                            title="Visualizar PDF"
                                                            type={"primary"}
                                                            icon={"fas fa-file-pdf"}
                                                            disabled={false}
                                                            visible={true}
                                                            event={() => {
                                                                const nomePdf = "contrato_horario_diferenciado";
                                                                props.setArquivoPDF(horarioDiferenciado.arquivo_contrato_horario, nomePdf);
                                                            }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <p style={{ padding: 20 }}>Ainda não há arquivo PDF</p>
                                                        <FileChooser
                                                            readOnly={readOnlyHorarioDiferenciado}
                                                            nome=""
                                                            base64=""
                                                            label={"Contrato Horário Diferenciado"}
                                                            onFileSelect={async (base64ComNomeJSON) => {
                                                                props.initForm({
                                                                    ...props.formularioValues,
                                                                    horario_diferenciado: {
                                                                        ...horarioDiferenciado,
                                                                        arquivo_contrato_horario: base64ComNomeJSON.base64,
                                                                    },
                                                                });
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                {!readOnlyHorarioDiferenciado && state.exibirCamposHorarioDiferenciado ? (
                                                        <Grid cols="12 12 12 12">
                                                            <Button
                                                                style={{ margin: 0 }}
                                                                text={"Salvar Horário Ponta Diferenciado"}
                                                                type={"success"}
                                                                icon={"fa fa-check"}
                                                                disabled={semAcessoCadastroHorarioDiferenciado}
                                                                event={() => {
                                                                    props.salvarHorarioDiferenciado(
                                                                        props.formularioValues
                                                                    );
                                                                }}
                                                            />
                                                        </Grid>
                                                ) : null}
                                            </Grid>
                                        </Row>
                                    </Grid>
                                ) : null}
                            </Row>
                        ) : null}
                    </ContentCardBody>
                </ContentCard>
                <Row style={{ paddingInline: 7 }}>
                    {props.listaDemandaContratoTipo.map((tipo) => {
                        const abas = listarAbasVisiveis(listaUCsSelect, props.formularioValues.id_unidade_consumidora);
                        if (!abas.includes(tipo.id)) return null;
                        const tipoSelecionado = props.filtro.id_tipo_contrato_demanda;
                        return (
                            <Grid
                                cols="4 4 4 4"
                                style={{
                                    padding: "15px 0px 5px 10px",
                                    backgroundColor: tipoSelecionado == tipo.id ? "#FFF" : "#EEE",
                                    color: tipoSelecionado == tipo.id ? "#000" : "#333",
                                    marginBottom: 0,
                                    zIndex: tipoSelecionado == tipo.id ? 1 : 0,
                                    borderRadius: "10px 10px 0 0",
                                    boxShadow: "#ddd 1px -7px 8px 1px",
                                    border: "solid 1px #ddd",
                                    borderBottom: "none",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    props.setFiltro({
                                        ...props.filtro,
                                        id_tipo_contrato_demanda: tipo.id,
                                    });
                                    props.atualizarValoresFormulario(props.formularioValues);
                                }}
                            >
                                <h6>{tipo.valor}</h6>
                            </Grid>
                        );
                    })}
                </Row>
                <ContentCard>
                    <ContentCardBody>
                        <Row style={{ padding: 9 }}>
                            <label>Contrato Atual</label>
                        </Row>
                        <Row style={{ paddingInline: 5 }}>
                            {listaCicloRural.map((cicloRural, i) => {
                                let sufixoTipoContrato = "";
                                switch (props.filtro.id_tipo_contrato_demanda) {
                                    case 1:
                                        sufixoTipoContrato = "";
                                        break;
                                    case 2:
                                        sufixoTipoContrato = "_ponta";
                                        break;
                                    case 3:
                                        sufixoTipoContrato = "_geracao";
                                        break;
                                }
                                return (
                                    <Field
                                        key={i}
                                        name={`valor_${i + 1}${sufixoTipoContrato}`}
                                        component={LabelAndInputNumber}
                                        label={cicloRural}
                                        placeholder="Informe a demanda"
                                        cols="12 6 4 3"
                                        casas={2}
                                        readOnly={readOnly}
                                    />
                                );
                            })}
                        </Row>

                        <Row alignCenter style={{ padding: "10px 10px 30px 0px" }}>
                            <Grid cols="12 4 4 4">
                                <Button
                                    text={"Agendar"}
                                    type={"primary"}
                                    icon={"fa fa-calendar-alt"}
                                    disabled={readOnly}
                                    event={() => {
                                        const valores1ao12 = retornaValores1ao12(props);
                                        const registro = {
                                            id_tipo_contrato_demanda: props.filtro.id_tipo_contrato_demanda,
                                            id_demanda_contrato: props.formularioValues.id,
                                            id_cliente: props.formularioValues.id_cliente,
                                            id_unidade_consumidora: props.formularioValues.id_unidade_consumidora,
                                            mes_inicio: props.formularioValues.mes_inicio,
                                            ...valores1ao12,
                                        };
                                        props.setModoTela("cadastroAgendamento", registro);
                                        props.initFormAgendamento(registro);
                                    }}
                                />
                            </Grid>
                            <Grid cols="12 4 4 4">
                                {props.excluir ? (
                                    <Button text="Excluir" submit type={"danger"} icon={"fa fa-trash"} />
                                ) : (
                                    <Button
                                        text={props.formularioValues.id ? "Atualizar Contrato Atual" : "Salvar"}
                                        submit
                                        type={"success"}
                                        icon={"fa fa-check"}
                                        disabled={props.visualizar}
                                    />
                                )}
                            </Grid>
                            <Grid cols="12 4 4 4">
                                <Button
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    event={() => {
                                        props.setModoTela("lista");
                                        props.getLista();
                                    }}
                                />
                            </Grid>
                        </Row>
                        {props.modoTelaDemandaCompetencia == "lista" ? listaItens(listaCicloRural, readOnly) : alterarDemandaCompetencia(listaCicloRural)}
                    </ContentCardBody>
                </ContentCard>
            </Form>
        </>
    );

    function renderizarLinhasDemandaCompetencia(listaCiclo, readOnly) {
        return listaCiclo.map((item) => {
            const listaDemandaCompetencia = [];
            for (let i = 1; i <= 12; i++) {
                listaDemandaCompetencia.push(`demandaCompetencia${i}`);
            }
            let mesAtual = parseInt(`${new Date().getFullYear()}${new Date().getMonth() < 9 ? "0" : ""}${new Date().getMonth() + 1}`);

            return (
                <NewTr
                    key={item.ano}
                    backgroundColorTr={mesAtual >= item.demandaCompetencia1.competencia && mesAtual <= item.demandaCompetencia12.competencia ? "#3f8" : ""}
                    botoes={[
                        {
                            type: "warning",
                            icon: "fas fa-pencil-alt",
                            disabled: readOnly ? true : false,
                            event: () => {
                                props.setListaDemandaCompetenciaAlteracao(
                                    "alteracao",
                                    [
                                        item.demandaCompetencia1,
                                        item.demandaCompetencia2,
                                        item.demandaCompetencia3,
                                        item.demandaCompetencia4,
                                        item.demandaCompetencia5,
                                        item.demandaCompetencia6,
                                        item.demandaCompetencia7,
                                        item.demandaCompetencia8,
                                        item.demandaCompetencia9,
                                        item.demandaCompetencia10,
                                        item.demandaCompetencia11,
                                        item.demandaCompetencia12,
                                    ].map((demandaCompetencia) => ({
                                        ...demandaCompetencia,
                                        quantidade: FormatUtils.formatarValorTela(demandaCompetencia.quantidade, 2),
                                    }))
                                );

                                props.getListaHistorico(props.formularioValues.id, item.demandaCompetencia1.competencia, item.demandaCompetencia12.competencia);
                            },
                        },
                    ]}
                >
                    <Td>{item.ano}</Td>
                    {listaDemandaCompetencia.map((demanda) => (
                        <Td alignCenter>{FormatUtils.formatarValorTela(item[demanda].quantidade, 2)}</Td>
                    ))}
                </NewTr>
            );
        });
    }

    function renderizarLinhasDemandaAgendamento(readOnly) {
        return props.listaAgendamento.map((item) => {
            const listaValores = [];
            for (let i = 1; i <= 12; i++) {
                listaValores.push(`valor_${i}`);
            }

            const valores = {};
            listaValores.forEach((valor) => (valores[valor] = FormatUtils.formatarValorTela(item[valor], 2)));
            const registro = {
                ...item,
                mes_inicio: props.formularioValues.mes_inicio,
                competencia_inicio_vigencia: `${String(item.competencia_inicio_vigencia).substring(4, 6)}/${String(item.competencia_inicio_vigencia).substring(0, 4)}`,
                ...valores,
            };

            return (
                <NewTr
                    key={item.id}
                    backgroundColorTr={item.executado ? "#5df" : "#fe4"}
                    botoes={[
                        {
                            type: "warning",
                            icon: "fas fa-pencil-alt",
                            disabled: readOnly,
                            event: () => {
                                props.setModoTela("cadastroAgendamento", registro);
                                props.initFormAgendamento(registro);
                            },
                        },
                        {
                            type: "danger",
                            icon: "fas fa-trash-alt",
                            disabled: readOnly,
                            event: () => {
                                props.setModoTela("exclusaoAgendamento", registro);
                                props.initFormAgendamento(registro);
                            },
                        },
                    ]}
                >
                    <Td minWidth={200}>
                        {item.executado ? "Agendamento Executado " : "Agendado "}
                        {String(item.competencia_inicio_vigencia).substring(4, 6)}/{String(item.competencia_inicio_vigencia).substring(0, 4)}
                    </Td>
                    {listaValores.map((valor) => (
                        <Td alignCenter>{FormatUtils.formatarValorTela(item[valor], 2)}</Td>
                    ))}
                </NewTr>
            );
        });
    }

    function listaItens(listaCicloRural, readOnly) {
        let listaCiclo = [];
        for (let i = 0; i < props.listaDemandaCompetencia.length; i += 12) {
            let anoInicial = props.listaDemandaCompetencia[i] ? parseInt(props.listaDemandaCompetencia[i].competencia / 100) : null;
            let anoFinal = props.listaDemandaCompetencia[i + 11] ? parseInt(props.listaDemandaCompetencia[i + 11].competencia / 100) : null;
            if (anoInicial && anoFinal) {
                listaCiclo.push({
                    ano: anoInicial == anoFinal ? anoInicial : `${anoInicial} até ${anoFinal}`,
                    demandaCompetencia1: props.listaDemandaCompetencia[i],
                    demandaCompetencia2: props.listaDemandaCompetencia[i + 1],
                    demandaCompetencia3: props.listaDemandaCompetencia[i + 2],
                    demandaCompetencia4: props.listaDemandaCompetencia[i + 3],
                    demandaCompetencia5: props.listaDemandaCompetencia[i + 4],
                    demandaCompetencia6: props.listaDemandaCompetencia[i + 5],
                    demandaCompetencia7: props.listaDemandaCompetencia[i + 6],
                    demandaCompetencia8: props.listaDemandaCompetencia[i + 7],
                    demandaCompetencia9: props.listaDemandaCompetencia[i + 8],
                    demandaCompetencia10: props.listaDemandaCompetencia[i + 9],
                    demandaCompetencia11: props.listaDemandaCompetencia[i + 10],
                    demandaCompetencia12: props.listaDemandaCompetencia[i + 11],
                });
            }
        }

        let anoHistoricoInicial = props.listaDemandaCompetencia[0] ? parseInt(props.listaDemandaCompetencia[0].competencia / 100) : null;
        let anoHistoricoFinal = props.listaDemandaCompetencia[11] ? parseInt(props.listaDemandaCompetencia[11].competencia / 100) : null;

        return (
            <ContentCard
                style={{
                    paddingTop: 20,
                    marginTop: 20,
                    boxShadow: "0px -2px 5px 1px #ccc",
                }}
            >
                <ContentCardHeader>
                    {props.formularioValues.id && listaCiclo.length > 0 && anoHistoricoInicial && anoHistoricoFinal ? (
                        <Row>
                            <Grid cols="12 12 4 4">
                                <Button
                                    text={`Adicionar Histórico para ${
                                        anoHistoricoInicial == anoHistoricoFinal ? anoHistoricoInicial - 1 : `${anoHistoricoInicial - 1} até ${anoHistoricoFinal - 1}`
                                    }`}
                                    type={"success"}
                                    icon={"fa fa-plus"}
                                    disabled={readOnly ? true : false}
                                    event={() => {
                                        props.adicionarHistorico(
                                            props.formularioValues.id,
                                            props.listaDemandaCompetencia.slice(0, 12).map((item) => ({
                                                ...item,
                                                id: null,
                                                competencia: item.competencia - 100,
                                            }))
                                        );
                                    }}
                                />
                            </Grid>
                        </Row>
                    ) : null}
                </ContentCardHeader>

                <ContentCardBody>
                    <Table responsive>
                        <THead>
                            <Tr>
                                <Th alignLeft width={200}>
                                    Ano
                                </Th>
                                {listaCicloRural.map((cicloRural) => (
                                    <Th key={cicloRural} alignCenter width={200}>
                                        {cicloRural}
                                    </Th>
                                ))}
                                <Th width={50}></Th>
                            </Tr>
                        </THead>
                        <TBody>
                            {renderizarLinhasDemandaCompetencia(listaCiclo, readOnly)}
                            {renderizarLinhasDemandaAgendamento(readOnly)}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    }

    function alterarDemandaCompetencia() {
        return (
            <>
                <ContentCard>
                    <ContentCardHeader>
                        <label>Alteração (só é possível alterar os históricos)</label>
                    </ContentCardHeader>

                    <ContentCardBody>
                        <Form>
                            <Row>
                                {props.listaAlteracaoDemandaCompetencia.map((item, i) => (
                                    <LabelAndInputNumber
                                        name="competencia"
                                        label={`${props.listaMeses.filter((mes) => mes.id == parseInt(String(item.competencia).substring(4, 6)))[0].valor} de ${parseInt(
                                            item.competencia / 100
                                        )}`}
                                        placeholder="Informe a demanda"
                                        cols="12 6 4 3"
                                        casas={2}
                                        value={item.quantidade}
                                        readOnly={
                                            item.competencia >= `${new Date().getFullYear()}${new Date().getMonth() < 9 ? "0" : ""}${new Date().getMonth() + 1}` ? "readOnly" : ""
                                        }
                                        onChange={(data) => {
                                            props.setListaDemandaCompetenciaAlteracao(
                                                "alteracao",
                                                props.listaAlteracaoDemandaCompetencia.map((demandaCompetencia) => {
                                                    return {
                                                        ...demandaCompetencia,
                                                        quantidade: demandaCompetencia.id == item.id ? data.target.value : demandaCompetencia.quantidade,
                                                    };
                                                })
                                            );
                                        }}
                                    />
                                ))}
                            </Row>
                        </Form>
                    </ContentCardBody>

                    <ContentCardFooter>
                        <Row alignCenter>
                            <Grid cols="6 6 4 3">
                                <Button
                                    text={"Salvar"}
                                    type={"success"}
                                    icon={"fa fa-check"}
                                    event={() => {
                                        props.alterarHistorico(props.formularioValues.id, props.listaAlteracaoDemandaCompetencia);
                                    }}
                                />
                            </Grid>
                            <Grid cols="6 6 4 3">
                                <Button text="Voltar" type={"warning"} icon={"fa fa-chevron-left"} event={() => props.setListaDemandaCompetenciaAlteracao("lista", [])} />
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                </ContentCard>

                <ContentCard>
                    <ContentCardBody>
                        <Row>
                            <Grid cols="12 12 12 12">
                                <Table responsive>
                                    <THead>
                                        <Tr>
                                            <Th colSpan={2}>Histórico</Th>
                                        </Tr>
                                    </THead>
                                    <TBody>
                                        {props.listaHistorico.map((item) => (
                                            <Tr>
                                                <Td width={150}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_alteracao)}</Td>
                                                <Td>{item.descricao}</Td>
                                            </Tr>
                                        ))}
                                    </TBody>
                                </Table>
                            </Grid>
                        </Row>
                    </ContentCardBody>
                </ContentCard>
            </>
        );
    }
}

const DemandaContratoFormRedux = reduxForm({
    form: "demandaContratoForm",
    destroyOnUnmount: false,
})(DemandaContratoForm);
const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    formularioValues: getFormValues("demandaContratoForm")(state),
    registro: state.demandaContrato.registro,
    lista: state.demandaContrato.lista,
    filtro: state.demandaContrato.filtro,
    listaCliente: state.demandaContrato.listaCliente,
    listaUnidadeConsumidora: state.demandaContrato.listaUnidadeConsumidora,
    listaDemandaContratoTipo: state.demandaContrato.listaDemandaContratoTipo,
    listaMeses: state.demandaContrato.listaMeses,
    listaDemandaCompetencia: state.demandaContrato.listaDemandaCompetencia,
    modoTelaDemandaCompetencia: state.demandaContrato.modoTelaDemandaCompetencia,
    listaAlteracaoDemandaCompetencia: state.demandaContrato.listaAlteracaoDemandaCompetencia,
    listaHistorico: state.demandaContrato.listaHistorico,
    listaAgendamento: state.demandaContrato.listaAgendamento,
    pdf: state.displayPDF.pdf,
    nomePdf: state.displayPDF.nomePdf,
    orientation: state.displayPDF.orientation,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            getLista,
            atualizarValoresFormulario,
            setFiltro,
            setArquivoPDF,
            getListaDemandaCompetencia,
            adicionarHistorico,
            alterarHistorico,
            setListaDemandaCompetenciaAlteracao,
            getListaHistorico,
            getListaAgendamento,
            initFormAgendamento,
            buscarHorarioDiferenciado,
            salvarHorarioDiferenciado,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(DemandaContratoFormRedux);

function retornaValores1ao12(props) {
    let sufixoTipoContrato = "";
    switch (props.filtro.id_tipo_contrato_demanda) {
        case 1:
            sufixoTipoContrato = "";
            break;
        case 2:
            sufixoTipoContrato = "_ponta";
            break;
        case 3:
            sufixoTipoContrato = "_geracao";
            break;
    }
    const valores = {};
    for (let i = 1; i <= 12; i++) {
        valores[`valor_${i}`] = props.formularioValues[`valor_${i}${sufixoTipoContrato}`];
    }
    return valores;
}

function listarAbasVisiveis(listaUCs, idUnidadeConsumidora) {
    const ucSelecionada = listaUCs.find((uc) => idUnidadeConsumidora == uc.id);
    if (!ucSelecionada) return [];

    // Regras para ilustrar as abas NO CADASTRO DE DEMANDA:
    const grupoA = [1, 4].includes(parseInt(ucSelecionada.id_grupo_faturamento));
    const horosazonalVerde = ucSelecionada.id_modalidade_tarifaria == 1;
    const horosazonalAzul = ucSelecionada.id_modalidade_tarifaria == 2;

    if (
        grupoA && // UNIDADE Grupo A
        horosazonalVerde && //Horossazonal Verde
        !ucSelecionada.geracao //Sem geração
    ) {
        return [1]; //ilustra apenas a aba FORA PONTA
    }
    if (
        grupoA && // UNIDADE Grupo A
        horosazonalVerde && //Horossazonal Verde
        ucSelecionada.geracao //COM geração
    ) {
        return [1, 3]; //ilustra apenas a aba FORA PONTA E DEMANDA G
    }

    if (
        grupoA && // UNIDADE Grupo A
        (horosazonalAzul || !ucSelecionada.id_modalidade_tarifaria) && //Horossazonal AZUL ou SEM Horossazonal
        !ucSelecionada.geracao //Sem geração
    ) {
        return [1, 2]; //ilustra apenas a aba FORA PONTA E PONTA
    }

    if (
        grupoA && // UNIDADE Grupo A
        (horosazonalAzul || !ucSelecionada.id_modalidade_tarifaria) && //Horossazonal AZUL ou SEM Horossazonal
        ucSelecionada.geracao //COM geração
    ) {
        return [1, 2, 3]; //ilustra a aba FORA PONTA E PONTA E DEMANDA G
    }
}
